import React from 'react'
import { Icon } from '@modul-connect/shared/components/atoms/icon'

export const SidebarIcon = ({ dark, icon, large, selected }) => {
  return <Icon dark={dark} icon={icon} large={large} selected={selected} size={large ? 36 : undefined} />
}
